import advancedOperations, {
    types as advancedOperationsTypes,
} from "./advanced-operations";
import general, { types as generalTypes } from "./general";
import move, { types as moveTypes } from "./select/manual/move";
import values, { types as valuesTypes } from "./values";

export const types = {
    ADVANCED_OPERATIONS: advancedOperationsTypes,
    GENERAL: generalTypes,
    VALUES: valuesTypes,
    MOVE: moveTypes,
};

export default {
    general,
    advancedOperations,
    values,
    types,
    move,
};
